<template>
    <div>
        <div class="left-box">
            <app-link class="logo" :to="appHost"></app-link>
        </div>
        <div class="right-box">
            <el-dropdown>
                <div class="avatar">
                    <el-avatar size="small" :src="avatar"></el-avatar>
                </div>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item @click.native="linkAccount">
                        <i class="icon el-icon-user"></i>账号信息
                    </el-dropdown-item>
                    <el-dropdown-item divided @click.native="logout">
                        <i class="icon el-icon-switch-button"></i>退出登录
                    </el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
        </div>

    </div>
</template>

<script>
import page from "./index.js";
export default page;
</script>

<style lang="scss" scoped>
@import "./index.css";
</style>


// WEBPACK FOOTER //
// src/layout/master/components/navbar/index.vue